import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Alert, Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import { patch } from '../../utils/api';

export default function PortalWelcomePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState('');

  const acceptWelcome = async () => {
    try {
      setSaving(true);
      setError('');
      await patch('/portal/me/preferences', { portalWelcomeAccepted: true });
      navigate(`/devotees/${id}/home`, {
        replace: true,
        state: { portalWelcomeJustAccepted: true },
      });
    } catch (e) {
      setError(e?.message || 'Could not save your acknowledgment. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 760, mx: 'auto', pt: { xs: 1, md: 3 } }}>
      <Card variant="outlined" sx={{ borderRadius: 3 }}>
        <CardContent sx={{ p: { xs: 2.5, sm: 4 } }}>
          <Stack spacing={2.5}>
            <Box>
              <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
                Welcome to the ICCT Devotee Portal
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Please review this quick note before continuing to your dashboard.
              </Typography>
            </Box>

            <Typography variant="body1">
              This portal is linked to the email address associated with your ICCT records. By continuing, you confirm
              that you are authorized to access and manage this devotee record.
            </Typography>

            <Typography variant="body1">
              Please review your profile information and update it if anything has changed.
            </Typography>

            <Typography variant="body2" color="text.secondary">
              If this is not your email or devotee record, please do not continue and contact ICCT for assistance.
            </Typography>

            {error ? <Alert severity="error">{error}</Alert> : null}

            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button variant="contained" onClick={acceptWelcome} disabled={saving} sx={{ minWidth: 132 }}>
                {saving ? <CircularProgress size={20} color="inherit" /> : 'Continue'}
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
